import { render, staticRenderFns } from "./SearchPanelComponent.vue?vue&type=template&id=ec0f1660&scoped=true&"
import script from "./SearchPanelComponent.vue?vue&type=script&lang=js&"
export * from "./SearchPanelComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0f1660",
  null
  
)

export default component.exports